import { render, staticRenderFns } from "./MenuItemList.vue?vue&type=template&id=4fe1ddfa&scoped=true&"
import script from "./MenuItemList.vue?vue&type=script&lang=js&"
export * from "./MenuItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1ddfa",
  null
  
)

export default component.exports